import { getErrorScreenName } from '@/components/shared/UnrecoverableError/helpers/get-error-screen-name'
import { UnrecoverableEventConfig } from '@/components/shared/UnrecoverableError/types'
import { BASE_PATH_ANALYTICS, BUTTONS_ANALYTICS } from '@/constants/analytics'
import type { ErrorCode } from '@/errors/classes/ErrorCode'
import {
  createAnalyticsManifest,
  EventDispatcherConfig,
} from '@/services/analytics'

type UnrecoverableErrorAnalyticsConfig = Partial<UnrecoverableEventConfig> & {
  error: ErrorCode
}

const eventDispatcherConfig = ({
  error,
  activity,
  screenPath,
}: UnrecoverableErrorAnalyticsConfig): EventDispatcherConfig => ({
  config: {
    activity,
    screenName: getErrorScreenName(error),
    screenPath: screenPath ?? BASE_PATH_ANALYTICS.PORTAL_OOBE,
  },
  defaultData: {
    actionAuxParams: new URLSearchParams({ errorCode: error.errorCode }),
  },
})

export const UnrecoverableErrorPageAnalytics = createAnalyticsManifest(
  eventDispatcherConfig,
  ({ dispatcher }) => ({
    fireExitSetupButtonClicked: () => {
      dispatcher.fireButtonClicked({
        controlName: BUTTONS_ANALYTICS.EXIT_SETUP,
      })
    },
  }),
)
